import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import { Box, Button, Stack, Typography } from "@mui/material";
import PropTypes from "prop-types";

import { TRACKING_CARD_SX } from "./trackingStyles";

const LoanRow = ({ label, value }) => (
  <Stack direction="row" justifyContent="space-between" alignItems="baseline" spacing={1}>
    <Typography variant="body2" color="text.secondary">
      {label}
    </Typography>
    <Typography variant="body2" fontWeight={700} sx={{ textAlign: "left" }}>
      {value}
    </Typography>
  </Stack>
);

LoanRow.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

const RequestLoanSummaryBox = ({ loanSummary, compact = false }) => {
  if (!loanSummary?.show) return null;

  const title = loanSummary.title || "اطلاعات مالی و وام مهرسان";

  return (
    <Box
      sx={{
        ...TRACKING_CARD_SX,
        p: compact ? 1.5 : 2,
        height: "100%",
        bgcolor: (t) => (t.palette.mode === "dark" ? "background.paper" : "#FAFCFF"),
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1.5 }}>
        <AccountBalanceOutlinedIcon sx={{ fontSize: 20, color: "primary.main" }} />
        <Typography variant="subtitle2" fontWeight={800}>
          {title}
        </Typography>
      </Stack>

      {loanSummary.active ? (
        <Stack spacing={1}>
          <LoanRow label="سقف وام" value={loanSummary.ceilingLabel} />
          {loanSummary.monthsLabel ? (
            <LoanRow label="مدت بازپرداخت" value={loanSummary.monthsLabel} />
          ) : null}
          <LoanRow label="قسط ماهانه" value={loanSummary.installmentLabel} />
          <Button
            variant="outlined"
            size="small"
            fullWidth
            sx={{ mt: 1, borderRadius: 2, fontWeight: 600 }}
            disabled
          >
            مشاهده جزئیات وام
          </Button>
        </Stack>
      ) : (
        <Typography variant="body2" color="text.secondary" lineHeight={1.65}>
          {loanSummary.note || loanSummary.loanTypeLabel || "اطلاعات وام در دسترس نیست."}
        </Typography>
      )}
    </Box>
  );
};

RequestLoanSummaryBox.propTypes = {
  loanSummary: PropTypes.object,
  compact: PropTypes.bool,
};

export default RequestLoanSummaryBox;
